export const environment = {
  production: true,
  buildId: '2549957492017681',
  configFile: 'config.json',
};
